import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import InputLabel from '@material-ui/core/InputLabel';
import Divider from '@material-ui/core/Divider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Ratings from 'react-ratings-declarative';
import SonicAction from './SonicAction'

function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing.unit * 2,
    backgroundColor: '#000000',
    padding: theme.spacing.unit,
  },
});



const lastResultCodes = [
  {name: 'APPT', color: '#036daf'},
  {name: 'Contacted', color: '#0089ba'},
  {name: 'Follow Up', color: '#06aa8f'},
  {name: 'Incorrect Person', color: '#ad03a4'},
  {name: 'DNC', color: '#757575'},
  {name: 'DNQ', color: '#ad0505'},
  {name: 'Give Up', color: '#b75e00'},
  {name: 'NI/Covered', color: '#a9055a'},
  {name: 'No_Contact', color: '#c63f81'},
  {name: 'Retry___', color: '#cc9502'},
  {name: 'SOLD', color: '#00af1a'},
  {name: 'Spanish', color: '#a3690d'},
  {name: 'Transfer', color: '#6b6b6b'},
  {name: 'Non-Working Number', color: '#ad03a4'},
]




class SonicCell extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        rating: 1
      };

    }


    changeRating = ( newRating ) => {
        console.log('changeRating')
        console.log(newRating)
        const { updateItem, id } = this.props;
        updateItem({id, type: 'keywordRating', value: newRating})
      }
    makeLabel = (value) => {
      if(value){
        const splitArray = value.split('_')
        if(splitArray.length > 1){
          return `${jsUcfirst(splitArray[0])} ${jsUcfirst(splitArray[1])}`
        }
        return jsUcfirst(value)
      }
      return ''
    }
    makeRating = () => {
        const { item } = this.props;
         const { keywordRating } = item;
        return (<Ratings
            widgetDimensions={'20px'}
            widgetSpacings={'2px'}
            rating={keywordRating}
            widgetRatedColors="#FFD700"
            changeRating={this.changeRating}
          >
            <Ratings.Widget widgetHoverColor="#FFD700"/>
            <Ratings.Widget widgetHoverColor="#FFD700"/>
            <Ratings.Widget widgetHoverColor="#FFD700"/>
            <Ratings.Widget widgetHoverColor="#FFD700"/>
            <Ratings.Widget widgetHoverColor="#FFD700"/>
          </Ratings>)
    }
    makeLastResultCodes = () => {
     
        return lastResultCodes.map(resultCode => {
            const { name } = resultCode
            return (
                <MenuItem key={name} value={name}>{name}</MenuItem>
            )
        })

    }
    makeStackCell = (props) => {
   
        const { classes, item, updateItem, id, cellSize } = this.props;
        const {campaignName, firstName, lastName, phone, email, postalCode, region, income, household, ageRange, lastResult, crmContactID, actions, leadPrice, keyword, soldDate, comment, condition, leadType, qualifier} = item

        return (
          <Paper className={classes.root}>
           
            <Grid container>
              
                
                 <Grid item container direction="row" justify="space-between">   
    
                            <Grid item xs={3} container direction="column" >
                                    <Grid item xs>
                                        <Typography gutterBottom variant="subheading">{`${firstName} ${lastName}`}</Typography>
                                        <Typography gutterBottom>{`${phone}`}</Typography>
                                        <Typography color="textSecondary">{`${postalCode}, ${region}`}</Typography>
                                        <Typography color="textSecondary">{`${soldDate}`}</Typography>
                                        {/*<ButtonBase> <Typography style={{marginTop: 20 }}>Edit</Typography></ButtonBase>*/}
                                    </Grid>
                                </Grid>
    
                            <Grid item xs={4} container direction="column" >
                                <Grid container>
                                    <Grid container direction="row" >
                                        <Grid item sm={7}>
                                            <Typography gutterBottom variant="subheading">{`Income: ${income}`}</Typography>
                                        </Grid>

                   
                                    </Grid>
                                </Grid>
                                <Grid item xs>
                                    <Typography gutterBottom>{`${email}`} </Typography>
                                </Grid>
                                <Grid item xs>
                                    <Typography color="textSecondary">{`Household: ${household}`}</Typography>
                                </Grid>
                                <Grid item xs>
                                    <Typography color="textSecondary">{`Age: ${ageRange}`} </Typography>
                                </Grid>
                            </Grid>

                            <Grid item xs={3} container direction="column" >
                            <Grid item xs>
                                 <Typography gutterBottom variant="subheading">{`${keyword}`}</Typography>
                                 <Typography gutterBottom variant="caption">{`Rate this keyword:`}</Typography>
                                 {this.makeRating()}
                            </Grid>
                            </Grid>
    
                            <Grid item xs={2} container direction="column" alignItems="flex-end"  > 
                                    <Grid item xs>
                                        <Typography variant="subheading">{campaignName}</Typography>
                                    </Grid>  
                                    <Grid item>
                                            <Typography variant="subheading">{`$${leadPrice / 100}`}</Typography>
                                    </Grid> 
                                    <Grid item>
                                            <Typography variant="subheading">{`${condition === 'none' ? 'Healthy' : this.makeLabel(condition)} (${this.makeLabel(leadType)} / ${this.makeLabel(qualifier)})`}</Typography>
                                    </Grid> 
                                    <Grid item xs>
                                            <Typography color="textSecondary">{`Actions: ${actions ? actions : 0}`}</Typography>
                                    </Grid>  
                
                                    {/*<Grid item xs>
                                    <FormControl className={classes.formControl} error>
                                    <InputLabel htmlFor="name-error">Last Result</InputLabel>
                                        <Select
                                            style={{width: 100}}
                                            value={lastResult ? lastResult : ''}
                                            onChange={(event) => updateItem({id, type: 'lastResult', value: event.target.value})}
                                            name="lastResult"
                                           // renderValue={value => `⚠️  - ${value}`}
                                        //  input={<Input id="name-error" />}
                                        >
                                           {this.makeLastResultCodes()}
                                        </Select>
                                    </FormControl>
                                    </Grid>    */}           
                            </Grid>
                    </Grid>
    
                   {<Grid item container direction="row" justify="flex-start" >   
                        <Grid item style={{marginTop: 20, width: '100%'}}>
                 
                        <SonicAction id={id} cellSize={cellSize} comment={comment} lastResult={lastResult} updateItem={updateItem} />
                  
                        </Grid>   
                </Grid>}
                </Grid>
          </Paper>
        );
      }
    makeListCell = () => {
        const { classes, item, updateItem, id } = this.props;
    
        const {firstName, lastName, phone, email, postalCode, region, income, household, ageRange, lastResult, actions, comment, leadPrice, soldDate, leadType, qualifier} = item
      
        //console.log(lastResult)

       // const backgroundColor = '#000000'
    
        return (
            <Paper className={classes.root}>
            <Grid container>
          <Grid item container direction="row" justify="flex-start">   
              
              <Grid item sm={1}>
                <Typography className={classes.paper}>{`${firstName} ${lastName}`}</Typography>
              </Grid>
              <Grid item sm={1}>
                <Typography className={classes.paper}>{`${phone}`}</Typography>
              </Grid>
              <Grid item sm={2}>
                <Typography className={classes.paper}>{`${email}`}</Typography>
              </Grid>
    
              <Grid item sm={1}>
              <Typography className={classes.paper}>{`${postalCode}, ${region}`}</Typography>
              </Grid>
    
              <Grid item sm={1}>
              <Typography className={classes.paper}>{`${income}`}</Typography>
              </Grid>
    
              <Grid item sm={1}>
              <Typography className={classes.paper}>{`Household: ${household}`}</Typography>
               </Grid>
    
             <Grid item sm={1}>
             <Typography className={classes.paper}>{`Age: ${ageRange}`}</Typography>
              </Grid>
             
              <Grid item sm={1}>
              <Typography className={classes.paper}>{`${soldDate}`}</Typography>
            </Grid>
    
             {/* <Grid item sm={1}>
              <ButtonBase> <Typography>Comment</Typography></ButtonBase>
        </Grid>*/}
    
               <Grid item sm={1}>
           
                                    <InputLabel htmlFor="name-error">Last Result</InputLabel>
                                        <Select
                                            style={{width: 100}}
                                            value={lastResult ? lastResult : ''}
                                            onChange={(event) => updateItem({id, type: 'lastResult', value: event.target.value})}
                                            name="lastResult"
                                           // renderValue={value => `⚠️  - ${value}`}
                                         //   input={<Input id="name-error" />}
                                        >
                                        {this.makeLastResultCodes()}
                                        </Select>
                     
                </Grid>
    
                
               <Grid item sm={1}>
               <Typography className={classes.paper}>{`Actions: ${actions ? actions : 0}`}</Typography>
                </Grid>
    
                            
               <Grid item sm={1}>
               <Typography className={classes.paper}>{`$${leadPrice / 100}`}</Typography>
                </Grid>
    
                </Grid>
      
             
    
    
            </Grid>
            </Paper>
        );
      }
    render() {
        const { classes, view } = this.props;

        if(view === 'cells'){
            return this.makeStackCell()
        }
        return this.makeListCell()
    }

}
  /*
function SonicCell(props) {
    const { classes, view } = props;
    if(view === 'cells'){
        return StackCell(props)
    }
    return ListCell(props)
}*/

SonicCell.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SonicCell);



// WEBPACK FOOTER //
// ./src/components/lib/SonicCell.js